@if (mutliFormSelectOptions$ | async; as options) {
  @if (options.options.length > 0) {
    <sh-form-multi-select-base
      [id]="'sort-table-by'"
      [multiple]="false"
      [formControl]="formControl"
      [options]="mutliFormSelectOptions$ | async"
      [openDirection]="openDirection"
      [style]="style"
      [prefixMsg]="'components.sort.by' | translate"
    ></sh-form-multi-select-base>
  }
}
